import React from 'react';
import {Modal} from 'react-bootstrap';
import './AddressModal.css';

const AddressModal = ({show, onHide, showRepresentation=true}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            scrollable
            aria-labelledby="contained-modal-title-vcenter"
            centered
            keyboard
            animation
            autoFocus
        >
            <Modal.Header closeButton>
                <Modal.Title>Адрес университета</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="address-modal-container">
                    <h5>Головная организация</h5>
                    <div className="address-modal-content">
                        <div className="address-modal-text">
                            <p>
                                Гжельский государственный университет находится по адресу:
                                <br/>
                                140155, Московская область, Раменский муниципальный округ,
                                пос. Электроизолятор, д.67
                            </p>
                        </div>
                        <div className="address-modal-map">
                            <iframe
                                title="Yandex Map"
                                src="https://yandex.ru/map-widget/v1/?ll=38.495352%2C55.588130&mode=search&oid=198121436745&ol=biz&z=16.45"
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                allowFullScreen
                                style={{border: '1px solid #ccc', borderRadius: '4px'}}
                            ></iframe>
                        </div>
                    </div>
                    <div className="address-modal-instructions">
                        <h5>Как добраться до головной организации:</h5>
                        <ul className="address-modal-instructions-list">
                            <li>От автостанции «Котельники» на междугородных автобусах № 325, № 369, № 376 (направления:
                                Егорьевск, Шатура, Рошаль) до остановки «Гжельский университет» в селе Новохаритоново.
                            </li>
                            <li>От Казанского вокзала на электричке (направление Шатура, Черусти, Куровское) до ж/д
                                станции «Гжель», далее автобусами № 36 или № 51; маршрутными такси № 63к или № 51 до
                                остановки «Гжельский университет» в селе Новохаритоново или на такси.
                            </li>
                            <li>От Казанского вокзала на электричке (направление Шатура, Черусти, Куровское) до ж/д
                                станции «Игнатьево». Далее пешком до ГГУ.
                            </li>
                            <li>Из г. Раменское: от автовокзала автобусами № 36 или № 51; маршрутными такси № 63к или № 51
                                до остановки «Гжельский университет» в селе Новохаритоново.
                            </li>
                        </ul>
                    </div>
                    {showRepresentation && (
                        <>
                            <h5>Представительство</h5>
                            <div className="address-modal-content">
                                <div className="address-modal-text">
                                    <p>
                                        Представительство Гжельского Госдуратсвенного университета находится по адресу:
                                        <br/>
                                        Краснодарский край, г. Сочи, ул. Советская, д. 42
                                    </p>
                                </div>
                                <div className="address-modal-map">
                                    <iframe
                                        title="Yandex Map"
                                        src="https://yandex.ru/map-widget/v1/?indoorLevel=1&ll=39.724813%2C43.586667&mode=search&ol=geo&ouri=ymapsbm1%3A%2F%2Fgeo%3Fdata%3DCgk3NzEyMDc5MjUSiwHQoNC-0YHRgdC40Y8sINCa0YDQsNGB0L3QvtC00LDRgNGB0LrQuNC5INC60YDQsNC5LCDQodC-0YfQuCwg0LzQuNC60YDQvtGA0LDQudC-0L0g0KbQtdC90YLRgNCw0LvRjNC90YvQuSwg0KHQvtCy0LXRgtGB0LrQsNGPINGD0LvQuNGG0LAsIDQyIgoNNeYeQhXAWC5C&z=16.51"
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        allowFullScreen
                                        style={{border: '1px solid #ccc', borderRadius: '4px'}}
                                    ></iframe>
                                </div>
                            </div>
                            <div className="address-modal-instructions">
                                <h5>Как добраться до представительства:</h5>
                                <ul className="address-modal-instructions-list">
                                    <li>В 2 минутах ходьбы от остановки общественного транспорта «Сбербанк».
                                    </li>
                                    <li>В 7 минутах ходьбы от железнодорожного вокзала «Сочи».
                                    </li>
                                    <li>В 10 минутах ходьбы от железнодорожной станции «Сочи».
                                    </li>
                                </ul>
                            </div>
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddressModal;